import { render, staticRenderFns } from "./Sendpassmail.vue?vue&type=template&id=4dddfc2b&scoped=true&"
import script from "./Sendpassmail.vue?vue&type=script&lang=js&"
export * from "./Sendpassmail.vue?vue&type=script&lang=js&"
import style0 from "./Sendpassmail.vue?vue&type=style&index=0&id=4dddfc2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddfc2b",
  null
  
)

export default component.exports